/** Video call cost is an estimate based on recorded usage, not a supplier invoice. */
export function videoSupplierCostState(cost) {
  if (!cost) return 'not_recorded'
  if (cost.supplier_cost_status === 'unknown' || cost.supplier_cost_status === 'recorded_estimate_not_supplier_invoice') return cost.supplier_cost_status
  if (cost.supplier_cost_status != null) return 'not_provided'
  if (!Object.hasOwn(cost, 'completion_tokens')) return 'not_provided'
  return Number(cost.completion_tokens) > 0 ? 'recorded_estimate_not_supplier_invoice' : 'unknown'
}

/** Preserve unknown or missing state rather than interpreting recorded zero as free. */
export function videoSupplierCostText(cost, t) {
  const state = videoSupplierCostState(cost)
  let text
  if (state === 'not_recorded') text = t('storyFilm.executionLog.notRecorded')
  else if (state === 'unknown') text = t('storyFilmReview.supplierCostUnknown')
  else if (state === 'not_provided') text = t('storyFilmReview.supplierCostUnspecified')
  else {
    const value = cost.recorded_supplier_cost_micros ?? cost.supplier_cost_micros
    if (value == null || value === '' || !Number.isFinite(Number(value))) text = t('storyFilmReview.supplierCostUnspecified')
    else text = t('storyFilmReview.supplierCostEstimate', { amount: `${(Number(value) / 1_000_000).toFixed(6)} ${cost.currency || t('storyFilm.executionLog.currencyUnknown')}` })
  }
  return cost?.billing_mode === 'record_only' ? `${text} · ${t('storyFilmReview.recordOnly')}` : text
}
